<div class="vb__utils__heading">
  <strong>
    {{ data.title }}
  </strong>
  <div class="text-muted font-size-15">{{ data.description }}</div>
</div>